var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1215,
    viewBox: "0 0 1440 1215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-525.687 570.736C-516.557 548.97 -322.2 267.522 -65.652 95.1229C164.446 -59.3274 461.062 -42.427 619.981 274.218C790.227 613.535 1016.81 780.476 1238.52 853.569C1457.46 925.489 1674.12 861.253 1788.61 805.291C2036.57 684.691 2139.51 921.818 1910.74 1142.29C1803.89 1244.58 1703.46 1228.44 1558.69 1154.28C1407.37 1076.77 1213.83 914.902 884.746 786.012C567.243 661.925 165.361 592.598 -120.235 647.626C-424.273 706.341 -606.525 759.906 -525.687 570.736Z",
    fill: "url(#paint0_linear_1240_5601)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1240_5601",
    x1: 1478.1,
    y1: 1622.71,
    x2: -17.6173,
    y2: -134.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1877F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E51E25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.e7887298525012155d6f062f1715f2e7.svg";
export { ForwardRef as ReactComponent };